module.exports = __webpack_public_path__ + "assets/img/micronet-manager.32822580.png";